import React from 'react';
import { greaseSelectionDetails } from '../../../components/bearing-search/api/api';
import { handleActionError } from '../../utils/engineering-tools';
import { GreaseSelectionPayload } from '../../../components/bearing-search/types/types';

export type GreaseSelectionState = {
	segment?: string;
	equipment?: string;
	application?: string;
	segmentOptions: string[];
	equipmentOptions: string[];
	applicationOptions: string[];
	requestData?: GreaseSelectionPayload;
};

type GreaseSelectionForm = Pick<GreaseSelectionState, 'segment' | 'equipment' | 'application'>;

const getGreaseSelectionOptions = ( filter: GreaseSelectionForm, key: keyof GreaseSelectionForm ): string[] => {
	const { segment, equipment } = filter;

	switch ( key ) {
		case 'segment': {
			const set = new Set<string>( greaseSelectionDetails.map( ( item ) => item.segment ) );
			return [ ...set ];
		}
		case 'equipment': {
			const set = new Set<string>( greaseSelectionDetails.filter( ( item ) => item.segment === segment ).map( ( item ) => item.equipment ) );
			return [ ...set ];
		}
		case 'application': {
			const set = new Set<string>( greaseSelectionDetails.filter( ( item ) => item.segment === segment && item.equipment === equipment ).map( ( item ) => item.application ) );
			return [ ...set ];
		}
	}
};

export const initialGreaseSelectionState: GreaseSelectionState = {
	segmentOptions: getGreaseSelectionOptions( {}, 'segment' ),
	equipmentOptions: [],
	applicationOptions: [],
};

export type GreaseSelectionAction =
	| { type: 'change_segment'; payload: string }
	| { type: 'change_equipment'; payload: string }
	| { type: 'change_application'; payload: string }
	| { type: 'reset'; payload?: GreaseSelectionState };

const greaseSelectionReducer: React.Reducer<
	GreaseSelectionState,
	GreaseSelectionAction
> = ( state, action ) => {
	switch ( action.type ) {
		case 'change_segment': {
			const segment = action.payload;
			const equipmentOptions = getGreaseSelectionOptions( { segment }, 'equipment' );
			return {
				...state,
				segment,
				equipmentOptions,
				equipment: undefined,
				application: undefined,
				applicationOptions: [],
				requestData: undefined,
			};
		}
		case 'change_equipment': {
			const equipment = action.payload;
			const { segment } = state;
			const applicationOptions = getGreaseSelectionOptions( { segment, equipment }, 'application' );

			return {
				...state,
				equipment,
				application: undefined,
				applicationOptions,
				requestData: undefined,
			};
		}
		case 'change_application': {
			const { segment, equipment } = state;
			const application = action.payload;
			let requestData: GreaseSelectionPayload | undefined;

			if ( segment && equipment && application ) {
				requestData = { segment, equipment, application };
			}

			return {
				...state,
				application,
				requestData,
			};
		}
		case 'reset': {
			const newState = action.payload ? action.payload : initialGreaseSelectionState;

			return {
				...newState,
			};
		}
	}

	return handleActionError( action );
};

export default greaseSelectionReducer;
